import type { ToolProgressItem } from "./tool-progress";

type Options = {
  busy: boolean;
};

/**
 * One live status line: latest active, else latest failed.
 * Completed calls are ignored.
 */
export function primaryToolProgressItem(
  items: ToolProgressItem[],
): ToolProgressItem | null {
  let latestActive: ToolProgressItem | undefined;
  let latestFailed: ToolProgressItem | undefined;
  for (const item of items) {
    if (item.status === "active") {
      latestActive = item;
    } else if (item.status === "failed") {
      latestFailed = item;
    }
  }
  return latestActive ?? latestFailed ?? null;
}

/**
 * Pick the single live status line for a busy turn.
 * Prefer the latest active call; otherwise the latest failed call.
 * Completed calls never appear — {@link AgentToolProgress} crossfades replacements.
 */
export function visibleToolProgressItems(
  items: ToolProgressItem[],
  options: Options,
): ToolProgressItem[] {
  if (!options.busy) return [];
  const primary = primaryToolProgressItem(items);
  return primary ? [primary] : [];
}
